<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules1" :labelWidth="labelWidth" :formGroups="formGroups"
      :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "TempEscortDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      baseUrl: 'shortescort',
      breadcrumb: [
        { name: "人员管理", path: "/staff/tempEscort" },
        { name: "打短押运管理", path: "/staff/tempEscort" },
        { name: "添加打短押运" },
      ],
      rules1: {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        tel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
      },
    };
  },
  methods: {},
  created() {
    this.formGroups.length = 1
    this.formGroups[0].formCtrl.splice(3, 2)
    this.formGroups[0].formCtrl.push({
      label: "押运员从业资格证",
      keyName: "escortcard",
      type: "file",
      tips: "最多上传2张图片",
      max: 2,
      className: "block",
    })
    this.getOptions();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
